import { PayloadAction } from '../../../store.model';
import { ActionType } from '../main.action';
import { defaultState, MainState } from '../main.state';

import { Reset } from './reset.action';

export function resetReducer(
    state: MainState,
    _: PayloadAction<ActionType.EVAL_MAIN__RESET, Reset>,
): MainState {
    return defaultState();
}
